import { Box, Button, Grid, Typography } from "@material-ui/core";
import React, { Fragment, useEffect, useState } from "react";
import { ProductList, ProductListItem } from "../../components/ProductList";
import { Locale } from "../../core/api/model";
import { getLocalizedValue } from "../../core/lang";
import SpinnerModal from "../../core/spinner-modal";
import {
  CorpFieldsFragment,
  useFindCorporationQuery,
} from "../../generated/platform";
import CustomIcon from "../../core/custom-icon";
import { useIntl } from "react-intl";

type Props = {
  corpId: number;
  locale: Locale;
  onRequestMeeting: (classification: any, corp: CorpFieldsFragment) => void;
  requestLabel: string;
};

export const CorporationProductList = ({
  corpId,
  locale,
  requestLabel,
  onRequestMeeting,
}: Props) => {
  const { formatMessage } = useIntl();
  const query = useFindCorporationQuery({
    variables: {
      corpId,
      expoCode: process.env.REACT_APP_EXPO_CODE || "",
    },
  });
  const { data, loading } = query;
  const [corp, setCorp] = useState<CorpFieldsFragment>();

  useEffect(() => {
    if (!loading && data?.exhibitor) {
      setCorp(data.exhibitor as CorpFieldsFragment);
    }
  }, [data, loading]);

  return (
    <Fragment>
      <SpinnerModal active={loading} />
      {corp && (
        <>
          <Grid container
                spacing={5}
          >
            <Grid item
                  md={6}
            >
              <Typography component='h1'
                   variant='h1'
                   color='primary'
              >
                {formatMessage(
                  {
                    id: "MeetingLobbyTitle",
                    defaultMessage: "Ihre Terminanfrage mit {name}.",
                  },
                  { name: getLocalizedValue(locale, corp.corpName) }
                )}
              </Typography>
              <Box mt={{xs: 2.5, md: 2 }} mb={{xs: 3, md: 3 }}>
                <Typography component='h2' variant='h3' color='primary'>
                  {getLocalizedValue(locale, corp.corpProfile)}
                </Typography>
              </Box>
            </Grid>
          </Grid>

          <ProductList>
            {corp.classification
              ?.filter((i) => !!i && !!i.expert)
              .map((i, k) => (
                <ProductListItem
                  key={k}
                  product={{
                    title: getLocalizedValue(locale, i?.classificationTitle),
                    description: getLocalizedValue(
                      locale,
                      i?.classificationDesc
                    ),
                  }}
                >
                  <Button
                    endIcon={<CustomIcon iconname={"videoCall"} />}
                    onClick={() => {
                      onRequestMeeting(i, corp);
                    }}
                  >
                    {requestLabel}
                  </Button>
                </ProductListItem>
              ))}
          </ProductList>
        </>
      )}
    </Fragment>
  );
};
